if( $('.template-page-workpage').length > 0) {
$(document).on("click", ".gridvideo", function(){
var demo = $(this).parents(".AllBlocks").attr("videosorce");
 $('#myIframe').attr('src', demo +'?autoplay=1') ;
 $('.GridVideoDetails').addClass('ActivePopup');
  $(".GridWrapper").children(".WorkInfoRow ").remove();
  if( $(this).parents(".AllBlocks").children(".GridLink").children(".achorBlocks").length > 0 ){
    var info = $(this).parents(".AllBlocks").children(".GridLink").children(".achorBlocks").children(".BeaconAllBlocks").html();
  }else{
    var info = $(this).parents(".AllBlocks").children(".GridLink").children(".BeaconAllBlocks").html();
  
  }
  $(".GridWrapper").append(info);
  
    $('html, body').animate({
      scrollTop: $('html, body').offset().top + 100,
    },1200);
})
}

if( $('.template-index').length > 0) {
$(document).on("click", ".gridvideo", function(){
var demo = $(this).parents(".AllBlocks").attr("videosorce");
 $('#myIframe').attr('src', demo +'?autoplay=1') ;
 $('.GridVideoDetails').addClass('ActivePopup');
  $(".GridWrapper").children(".WorkInfoRow ").remove();
  if( $(this).parents(".AllBlocks").children(".GridLink").children(".achorBlocks").length > 0 ){
    var info = $(this).parents(".AllBlocks").children(".GridLink").children(".achorBlocks").children(".BeaconAllBlocks").html();
  }else{
    var info = $(this).parents(".AllBlocks").children(".GridLink").children(".BeaconAllBlocks").html();
  
  }
  $(".GridWrapper").append(info);
  
    $('.GridWrapper').animate({
      scrollTop: $('html, body').offset().top + 10,
    },1200);
})

}




$(document).on("click", ".CrossSvgIcon", function(){
 $('.GridVideoDetails').removeClass('ActivePopup');
  $('#myIframe').attr('src', " ") ;
 $(".GridWrapper").children(".WorkInfoRow ").html(" ");
})



$(document).on("click",".header__icon--summary",function(){
  $("body").toggleClass("Activee");
});


  // WINDOW LOAD.
$(window).on('load',function() {
  $(".AllBlocks").each(function(){
    var att = $(this).attr("alt");
    $('.WorkPg').each(function(){
      var obj = $(this);
      var txt = obj.children('span').text();
      if(att == txt == true ) {
         obj.trigger('click');
       }
    });
  });
          
});

// WINDOW LOAD END.



// CLICK NAVIGATION ON THE OUR WORK PAGE. 
$(document).on("click",".Our_WorkPage",function(e){
   e.preventDefault();

   $('.GridVideoDetails').removeClass('ActivePopup');
  $('#myIframe').attr('src', " ") ;
 $(".GridWrapper").children(".WorkInfoRow ").html(" ");
    var clk = $(this);
  
    var txt = clk.children('span').text();
    $('.AllBlocks').each(function(){
        var obj = $(this);
        var alt = obj.attr('alt')
        if(txt == alt == true){
            obj.addClass('NewDisBlocks');
            clk.addClass('ohhYeah');
           }
        else {
            obj.removeClass('NewDisBlocks');
            clk.addClass('ohhYeah'); 
        }
    });
});


$(document).on('click', '.VideoSettinginfo', function () {
    var VideoHm = $(this).children('.Bvideo').children('.CustomVideostruc').children('video');
    VideoHm = VideoHm.get(0);

    var simianLeftCont = $(this).children('.Simianleftcont');

    if (VideoHm.paused) {
        $('video').each(function () {
            $(this).get(0).pause();
        });
        $('.MainButtonWrapper').each(function () {
            $(this).css('opacity', '1');
        });
        VideoHm.play();
        $(this).addClass("removeoverlay");
       $('.MainHeaderinfo').css('opacity', '0');
         $(this).children('.MainButtonWrapper').css('opacity', '0');
       $('.MainButtonWrapper').removeClass("addedopcity");
        $(this).children(".CrossSVGIcons").addClass("VideoHidden");
        simianLeftCont.addClass('simiancontent');
    } else {
        VideoHm.pause();
        $(this).removeClass("removeoverlay");
      $('.MainHeaderinfo').css('opacity', '1');
         $(this).children('.MainButtonWrapper').css('opacity', '1');
        simianLeftCont.removeClass('simiancontent');
    }

    if (simianLeftCont.hasClass('simiancontent')) {
        simianLeftCont.fadeIn();
    } else {
        simianLeftCont.fadeOut();
    }  
 VideoHm.onended = function() {
   const sliderVIDEO = $(".BeaconImageSubmain");
    var currentSlide = sliderVIDEO.slick('slickCurrentSlide');
    var TotalSlide = sliderVIDEO.slick('getSlick').slideCount - 0
   
   if( currentSlide < TotalSlide){
    sliderVIDEO.slick('slickGoTo', currentSlide + 1);
    currentSlide = sliderVIDEO.slick('slickCurrentSlide');
      $('video').each(function(){
      $(this).get(0).pause();
        
    });     
    $(this).children('.MainButtonWrapper').css('opacity','0');
      $('.MainHeaderinfo').css('opacity', '0');
     
   }else{
      $('video').each(function(){
      $(this).get(0).pause();
    });     
     $(this).children('.Simianleftcont').removeClass('simiancontent');
    $(this).children('.MainButtonWrapper').css('opacity','1');
      $('.MainHeaderinfo').css('opacity', '1');
      $(this).removeClass("removeoverlay");
     
     
     
    sliderVIDEO.slick('slickGoTo', currentSlide - 1);
    currentSlide = sliderVIDEO.slick('slickCurrentSlide');
   }
};
})


$(document).on('click', '.iconPlaybutton', function(){
  $(this).parents('.AllBlocks').addClass("addCirclleloader").siblings().removeClass('addCirclleloader');
})


$(document).on('click', '.CrossSvgIcon', function(){
$('.AllBlocks').removeClass("addCirclleloader");
  
})

$(document).on('click', '.list-menu li', function(){
$('.AllBlocks').removeClass('addCirclleloader');
})

$(document).on('click', '.homeplaybtn', function(){
var homevd = $(this).parents(".VideoGridSection").children("video");
  homevd = homevd.get(0);
   if ( homevd.paused ) {
    $('video').each(function(){
      $(this).get(0).pause();
    });
    $(".homeplaybtn").each(function(){
      $(this).css('opacity','1');
    });    
   homevd.play();
   $(this).css('opacity','0');
  }else{
   homevd.pause();
   $(this).css('opacity','1');    
  }
})


$(document).on('click','.WorkGridWrapper', function(e){
  e.preventDefault();
 


  var VideoCaptured = $(this).attr('VideoSourceGet');
  var client = $(this).attr('client'); 
   var projetc = $(this).attr('project');
  var agency = $(this).attr('agency'); 
  var director = $(this).attr('director');  
  var role = $(this).attr('role');
  if( director !== "undefined" ){ var director2 = $(this).attr('director'); var data_director = "Director: "+director2}else{ var director2 ='';   var data_director = '';}
  if( agency !== "undefined" ){ var agency2 = $(this).attr('agency');var data_agency = "Agency: "+agency2}else{var agency2 =''; var data_agency = '';}
  if( role !== "undefined" ){ var role2 = $(this).attr('role'); var data_role = "Beacon Street: "+role2 }else{ var role2 =''; var data_role = '';}
   if( client !== "undefined" ){ var client2 = $(this).attr('client'); var data_client = client2 }else{ var client2 =''; var data_client = '';}
  if( projetc !== "undefined" ){ var projetc2 = $(this).attr('project'); var data_projetc = projetc2 }else{ var projetc2 =''; var data_projetc = '';}
   if ($(window).width() <= 767) {
  $('body').append(
    `
      <div class="SimianVideoGrid">
        
        <div class="video_overlay"></div>
        <div class="MainVideoPopup">
          <div class="Video_popup simianVdpop">
          ${VideoCaptured}
          </div>
        </div>
        <div class="SimianVideo_content" style="display:none;">
          
          <span class="gridagency">${data_agency}</span>
           <span class="griddirector">${data_director}</span> 
            <span class="gridrole">${data_role}</span> 
         </div>
      </div>               
    `
    );
    }else
   {
       $('body').append(
    `
      <div class="SimianVideoGrid">
        
        <div class="video_overlay"></div>
        <div class="MainVideoPopup">
          <div class="Video_popup simianVdpop">
          ${VideoCaptured}
          </div>
        </div>
        <div class="SimianVideo_content" style="display:none;">
          <span class="gridagency">${data_agency}</span>
           <span class="griddirector">${data_director}</span> 
            <span class="gridrole">${data_role}</span> 
         </div>
      </div>               
    `
   
  );
   }
  $(".SimianVideoGrid video").trigger("play");
  
  
   $('.SimianVideoGrid .MainVideoPopup').addClass('Videopopup');
    $('body').addClass('HiddenScrollBy VideoACtive');  
$('.SimianVideo_content').css('display','block');
 
    $('#loading').css("display","block");

  setTimeout(function(){
    if(!$('.SimianVideoGrid video').get(0).paused){
      $('#loading').hide();
    }else{
      $('#loading').show();
    }
  },700)
  
  
})
$(document).on('click','.VideoCrossIcon', function(){
  $('.SimianVideoGrid').remove();  
  $('body').removeClass('HiddenScrollBy VideoACtive');
 
});


 $(document).on('click','.video_overlay', function(e){

    if ($(".MainVideoPopup").hasClass("Videopopup")) {
$(".MainVideoPopup").removeClass('Videopopup');
       $(".SimianVideoGrid video").trigger("pause");
}else{
                 $('.SimianVideoGrid').remove();
  $('body').removeClass('HiddenScrollBy VideoACtive');
      $('#loading').css("display","none");
}

   

}); 

$
  $(document).mouseup(function (e) { 
    if ($(window).width() <= 767) {
            if ($(e.target).closest(".MainVideoPopup").length 
                        === 0) { 
                             $('.SimianVideoGrid').remove();
  $('body').removeClass('HiddenScrollBy VideoACtive');
            }

      $(document).on('click','.MainVideoPopup',function(){
$('body').removeClass('HiddenScrollBy VideoACtive');
        $(".SimianVideoGrid video").trigger("pause");
    
});
    }
        }); 


$(document).ready(function () {  
  
  let scrollTimer; 
  $(window).scroll(function () {
    const scrollTop = $(this).scrollTop();
    const menuWorkGridTop = $('.MenuWorkGrid').offset().top;
    const delayDuration = 500; 

    
    clearTimeout(scrollTimer);

    if (scrollTop <= menuWorkGridTop) {
      
      scrollTimer = setTimeout(function () {
        $('body').removeClass('Activework');
      }, delayDuration);
    }
  });
});



$(document).ready(function(){

$(document).on('click', '.WORK a', function(e) {
    e.preventDefault();
  
  $('body').removeClass('videoScrolled');
    
   $('.MainWorkGrid_Section').removeClass('Custom_hidden');
    setTimeout(function() {
           $('html, body').animate({
        scrollTop: $("#shopify-section-template--20721622679853__54ed2cb8-4488-4093-a51b-b732c39ad052").offset().top
    }, 1000);
      
  $('.Our_WorkPage[data-attr="all"]').trigger('click');
    },1200);

});



$(document).on('click', 'button.slick-next.slick-arrow.slick-disabled', function() {
    $('body').removeClass('videoScrolled');
    $('.MainWorkGrid_Section').removeClass('Custom_hidden');
});


  

});

$(function() {
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    $('body').addClass('safari-mac');
  }
});